import { Controller } from "react-hook-form";
import { Label, UploadFileNew } from "components";
import { FormUploadNewStyled } from "./styled";

const FormUploadNew = ({
  theme_upload_set_image,
  control,
  name,
  label,
  subLabel,
  required = false,
  acceptType = "cover",
  maxMBFileSizeWarning,
  width = "100%",
  heightBox,
  useOnchangeRemoveEvent = true,
  iconHeight = "40",
  iconWidth = "40",
  labelTop,
  labelBottom,
  widthImageSize,
  heighImageSize,
  maxLength,
  desc_text,
  theme_left_right = false,
  disabled,
  dataTestId,
  errors,
  multiple,
  ...rest
}) => (
  <FormUploadNewStyled>
    <div className="box_input_item">
      <Label.LabelForm label={label} required={required} subLabel={subLabel} />
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <UploadFileNew
            theme_upload_set_image={theme_upload_set_image}
            acceptType={acceptType}
            maxMBFileSizeWarning={maxMBFileSizeWarning}
            width={width}
            heightBox={heightBox}
            value={field.value}
            onChange={field.onChange}
            useOnchangeRemoveEvent={useOnchangeRemoveEvent}
            iconHeight={iconHeight}
            iconWidth={iconWidth}
            labelTop={labelTop}
            labelBottom={labelBottom}
            maxLength={maxLength}
            desc_text={desc_text}
            theme_left_right={theme_left_right}
            widthImageSize={widthImageSize}
            heighImageSize={heighImageSize}
            disabled={disabled}
            dataTestId={dataTestId}
            name={name}
            multiple={multiple}
            {...rest}
          />
        )}
      />
      {errors ? <div className="field_error">{errors}</div> : null}
    </div>
  </FormUploadNewStyled>
);

export default FormUploadNew;
